import { Dispatch, UnknownAction } from "redux";
import { ACCOUNT_MODE_MODAL_CHOOSE_GUEST } from "./AccountModeModalActionTypes";

export const chooseGuestModeAction = () => (dispatch: Dispatch<UnknownAction>) =>
  dispatch({ type: ACCOUNT_MODE_MODAL_CHOOSE_GUEST });
